import script from "./rediantuijian.vue?vue&type=script&setup=true&lang=js"
export * from "./rediantuijian.vue?vue&type=script&setup=true&lang=js"

import "./rediantuijian.vue?vue&type=style&index=0&id=12753a98&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12753a98"]])

export default __exports__